module.exports = __webpack_public_path__ + "static/media/11n.03433398.png";